<template>
  <v-card id="promotion-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <v-data-table
      :headers="headers"
      :items="contacts"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >
      <template #[`item.phoneNumber`]="{item}">
        {{ item.phoneNumber }}
      </template>

      <template #[`item.initials`]="{item}">
        {{ item.initials }}
      </template>

      <template #[`item.nextSmsTime`]="{item}">
        <span
          v-if="isSmsBlocked(item)"
          class="error--text"
        >
          {{ toTimeString(item.nextSmsTime) }}
        </span>
        <span v-else>—</span>
      </template>

      <template #[`item.actions`]="{item}">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              small
              :disabled="hasNotPermission('Permissions.CustomerSmsLimitReset')"
              :loading="resettingId === item.id"
              v-bind="attrs"
              v-on="on"
              @click="reset(item.id)"
            >
              <v-icon size="18">
                {{ icons.mdiLockReset }}
              </v-icon>
            </v-btn>
          </template>
          <span>Снять SMS-лимит</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { mdiLockReset } from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import { hasPermission } from '@/helpers'

export default {
  name: 'CustomerList',
  data: () => ({ icons: { mdiLockReset }, resettingId: null }),
  computed: {
    ...mapFormHandlers('customer', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('customer', {
      contacts: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Номер телефона', value: 'phoneNumber' },
        { text: 'Инициалы', value: 'initials' },
        { text: 'Кодов отправлено', value: 'smsCount' },
        { text: 'Блокировка до', value: 'nextSmsTime' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Клиенты'
    await this.fetchContacts()
  },
  methods: {
    ...mapActions('customer', {
      fetchContacts: 'fetchList',
      resetSmsLimit: 'resetSmsLimit',
    }),
    hasNotPermission(val) {
      return !hasPermission(val)
    },

    blockedUntil(item) {
      return item.nextSmsTime ? moment.utc(item.nextSmsTime).local() : null
    },
    toTimeString(val) {
      return moment.utc(val).local().format('YYYY-MM-DD HH:mm:ss')
    },

    isSmsBlocked(item) {
      const until = this.blockedUntil(item)

      return !!until && until.isAfter(moment())
    },
    async reset(id) {
      this.resettingId = id
      try {
        await this.resetSmsLimit(id)
      } finally {
        this.resettingId = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
